import React, { useState, useEffect } from "react";
import { Container, ProgressDone, Link, Status, DeleteButton } from "./styles";

export default function ProgressBar({
  percent,
  name,
  url,
  onRemoveFile,
  readOnly,
  mode,
}) {
  const [style, setStyle] = useState({});

  useEffect(() => {
    setStyle({
      // Terminado el envío la línea ya no dice nada: se apaga.
      opacity: percent === 100 ? 0 : 1,
      width: `${percent}%`,
    });
  }, [percent]);

  const done = percent === 100;

  return (
    <Container mode={mode}>
      <Link mode={mode} target="_blank" rel="noopener noreferrer" href={url}>
        {name}
      </Link>

      <Status mode={mode}>{done ? "Listo" : `${percent}%`}</Status>

      {!readOnly && (
        <DeleteButton
          mode={mode}
          onClick={() => {
            onRemoveFile(name);
          }}
        />
      )}

      <ProgressDone style={style} />
    </Container>
  );
}
